export const SHORT_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const ALTERNATIVE_DATE_FORMAT = 'MM/DD/YY';
export const START_DATE_NAMES = [
  'booking-start',
  'date',
  'start',
  'booking',
  'event',
  'from',
  'delivery',
  'delivery date',
  'service date',
  'día',
  'datum',
  'alkaen',
  'rent from'
];
export const END_DATE_NAMES = ['booking-finish', 'booking-end', 'to', 'finish', 'return', 'return date', 'rent to'];
export const START_TIME_NAMES = ['start-time', 'booking-time', 'time', 'hora', 'zeit', 'heure', 'booking time'];
export const END_TIME_NAMES = ['finish time', 'finish-time'];
